import type { SnackbarType } from '@/types/SnackbarType';
import type { SnackbarActionsType, SnackbarStateType } from '@/types/stores/SnackbarStoreTypes';
import { type _GettersTree, defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid';

export const useSnackbarStore = defineStore<
    'snackbarStore',
    SnackbarStateType,
    _GettersTree<SnackbarStateType>,
    SnackbarActionsType
>('snackbarStore', {
    state: () => ({ snackbars: [] }),
    actions: {
        addSnackbar(snackbar: SnackbarType): void {
            snackbar.id = uuidv4();
            this.snackbars.push(snackbar);
        },
        removeSnackbar(snackbar: SnackbarType): void {
            const index = this.snackbars.indexOf(snackbar);
            if (index > -1) {
                this.snackbars.splice(index, 1);
            }
        },
    },
});
